exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".support-dialog-cls[data-v-485dfaac] .el-dialog .el-dialog__title {\n  font-size: 18PX;\n}\n.support-dialog-cls[data-v-485dfaac] .el-dialog .el-button--small {\n  font-size: 12PX;\n}\n.support-dialog-cls .item[data-v-485dfaac] {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 0.052083rem;\n}\n.support-dialog-cls .item .item-label[data-v-485dfaac] {\n  width: 0.729167rem;\n  font-size: 12PX;\n}\n.support-dialog-cls .item .item-content[data-v-485dfaac] {\n  width: calc(100% - 0.833333rem);\n  font-size: 12PX;\n}\n[data-v-485dfaac] .logo-uploader .el-upload--text {\n  width: 1.979167rem;\n  font-size: 12PX;\n}", ""]);

// exports
